import React from "react";

export default function TextSection({ heading, body }) {
  return (
    <div className="sx-container">
      <div className="sx-card">
        {heading && <h3 className="sx-heading">{heading}</h3>}

        {Array.isArray(body) &&
          body.map((para, idx) => (
            <p key={idx} className="sx-paragraph">
              {para}
            </p>
          ))}
      </div>
    </div>
  );
}
